export const COMPLAINT_MANAGEMENT_ROLES = ["super_admin"];
export const canManageComplaints = roles => Array.isArray(roles) && COMPLAINT_MANAGEMENT_ROLES.some(role => roles.includes(role));
export const COMPLAINT_STATUSES = {
  received: { label: "Received", badge: "warning" },
  reviewing: { label: "Under review", badge: "info" },
  handling: { label: "In progress", badge: "primary" },
  resolved: { label: "Resolved", badge: "success" },
  closed: { label: "Closed", badge: "secondary" },
};
export const COMPLAINT_CATEGORIES = {
  appointment: "Appointments / callbacks", service: "Staff service", equipment: "Sleep equipment / CPAP",
  report: "Reports / documents", portal: "Website", other: "Other / suggestions",
};
export const complaintTransitions = status => ({ received: ["reviewing", "handling", "resolved"], reviewing: ["handling", "resolved"], handling: ["reviewing", "resolved"], resolved: ["reviewing", "closed"], closed: ["reviewing"] }[status] || []);
export const complaintEmailLabel = complaint => {
  const delivery = { SUCCESS: "Accepted by mail server", ERROR: "Delivery failed", PROCESSING: "Sending", PENDING: "Waiting to send" };
  return delivery[complaint.emailDeliveryState] || ({ pending: "Waiting to queue", queued: "Queued", not_requested: "Not requested" }[complaint.apologyEmailStatus] || "Not requested");
};
export const filterComplaints = (rows, { status = "", category = "", search = "" } = {}) => {
  const term = search.trim().toLowerCase();
  return rows.filter(item => (!status || (status === "active" ? !["resolved", "closed"].includes(item.status) : item.status === status)) &&
    (!category || item.category === category) && (!term || [item.reference, item.contact.name, item.contact.email, item.contact.phone, item.bookingReference, item.assignedTo]
      .some(value => String(value || "").toLowerCase().includes(term))));
};
